<ix-layout-grid columns="12" class="h-100 d-flex flex-column">
  <ix-row>
    <ix-col size="11">
      <ix-content-header
        headerTitle="{{ 'um.headline' | translate }}"
        id="listUserHeader"
      ></ix-content-header>
    </ix-col>
    <ix-col class="d-flex flex-row-reverse" size="1">
      @if (WindowSizeService.windowSizeSmall()) {
        <ix-icon-button
          [routerLink]="'/app/invite-user'"
          icon="add"
          oval
          variant="primary"
        ></ix-icon-button>
      }
    </ix-col>
  </ix-row>
  @if (!loading) {
    <ix-row>
      <ix-col size="6" sizeSm="12">
        <ix-category-filter
          (filterChanged)="onFilterChange($event)"
          [suggestions]="suggestions"
          class="w-100"
          i18nPlainText="{{ 'um.filter_by_role' | translate }}"
          id="listUserFilter"
          placeholder="{{ 'um.filter_by_role' | translate }}"
          [uniqueCategories]="true"
        ></ix-category-filter>
      </ix-col>
      <ix-col class="d-flex flex-row-reverse" size="6" sizeSm="0">
        @if (!WindowSizeService.windowSizeSmall()) {
          <ix-button
            [routerLink]="'/app/invite-user'"
            icon="add"
            id="listUserInviteButton"
            variant="primary"
            >
            {{ 'um.add_user' | translate }}
          </ix-button>
        }
      </ix-col>
    </ix-row>
  }
  @if (loading) {
    <ix-row>
      <ix-col class="d-flex flex-row justify-content-center">
        <ix-spinner size="large"></ix-spinner>
      </ix-col>
    </ix-row>
  }
  @if (!loading) {
    <ix-row class="flex-grow-1">
      @if (initialUserList.length > 0) {
        <ix-col
          class="h-100 overflow-auto"
          size="12">
          @if (!loading && initialUserList.length > 0) {
            <ag-grid-angular
              (gridReady)="onGridReady($event)"
              [columnDefs]="columnDefs"
              [gridOptions]="gridOptions"
              [rowData]="userList"
              [suppressCellFocus]="true"
              class="w-100 h-100"
              id="listUserTable">
            </ag-grid-angular>
          }
        </ix-col>
      }
      @if (initialUserList.length === 0) {
        <ix-col size="12">
          <ix-empty-state
            [routerLink]="'/app/invite-user'"
            action="{{ 'um.add_user' | translate }}"
            class="no-user"
            header="{{ 'um.no_user_available' | translate }}"
            icon="add"
            subHeader="{{ 'um.add_user_first' | translate }}"
          ></ix-empty-state>
        </ix-col>
      }
    </ix-row>
  }
</ix-layout-grid>


<ng-template #modalUserDeletion let-modal>
  <ix-modal>
    <ix-modal-header>
      {{
      'um.delete.headline' | translate : {
      firstName: modal.data.firstName,
      lastName: modal.data.lastName
    }
    }}
  </ix-modal-header>
  <ix-modal-content>
    {{
    'um.delete.text' | translate : {
    firstName: modal.data.firstName,
    lastName: modal.data.lastName
  }
  }}
</ix-modal-content>
<ix-modal-footer>
  <ix-button (click)="modal.close('okay')" class="close-modal"
    onkeypress=""
    variant="secondary">
    {{ 'general.ok' | translate }}
  </ix-button>
  <ix-button (click)="modal.dismiss('dismiss')" class="dismiss-modal"
    onkeypress=""
    variant="primary">
    {{ 'general.cancel' | translate }}
  </ix-button>
</ix-modal-footer>
</ix-modal>
</ng-template>

